<template>
  <div>
    <h6 v-if="title">{{ title }}</h6>
    <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <span class="input-group-text" v-if="!extra.singleDate">Algus</span>
          <span class="input-group-text" v-if="extra.singleDate">Kuupäev</span>
          <input type="date" class="form-control" v-model="start" />
        </div>
      </div>
      <div v-if="!extra.singleDate" class="col">
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon2">Lõpp</span>
          <input type="date" class="form-control" :max="date" v-model="end" />
        </div>
      </div>
      <div v-if="extra.modes.length !== 0" class="col">
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon3">Arvestus</span>
          <select class="form-select" v-model="mode">
            <option v-for="(mode, index) in extra.modes" :key="index" :value="mode.type">{{ mode.name }}</option>
          </select>
        </div>
      </div>
      <div class="col">
        <div class="d-grid">
          <button v-if="!loading" type="button" class="btn btn-primary" @click="generateReport">Kuva</button>
          <button v-if="loading" type="button" class="btn btn-primary">
            <div class="spinner-border spinner-border-sm text-light" role="status"></div>
          </button>
        </div>
      </div>
      <div v-if="tableRows !== null && extra.export !== false" class="col">
        <div class="d-grid">
          <button type="button" class="btn btn-success" @click="downloadCSVData">
            Ekspordi
            <i class="fas fa-file-excel"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Totals -->
    <div v-if="totalData !== null" class="row g-2 mb-2">
      <div v-for="(total, index) in totalData" :key="index" class="col">
        <div class="card">
          <div class="card-body p-2">
            {{ total.name }}
            <h4>{{ total.value }}</h4>
          </div>
        </div>
      </div>
    </div>
    <!-- Chart -->
    <!-- Table -->
    <div v-if="tableCols" class="row">
      <div class="col">
        <table class="table table-striped">
          <thead>
          <tr>
            <th v-for="(col, index) in tableCols" :key="index">{{ col }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, index) in tableRows" :key="index">
            <td v-for="(value, index) in row" :key="index">{{ value }}</td>
            <td v-if="row.length === 0" class="table-primary" colspan="100%"></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra'],
  data () {
    return {
      loading: false,
      date: null,
      start: null,
      end: null,
      mode: 'hour',
      totalData: null,
      tableCols: null,
      tableRows: null,
      csv: null,
      csvAnchor: null
    }
  },
  sockets: {
    getTable: function (data) {
      console.log(data)
      if (data.reqData.id === this.extra.id) {
        this.totalData = data.totalData
        this.tableCols = data.tableOptions.tableHeaders
        this.tableRows = data.tableOptions.tableRows
        this.csv = data.csv
        this.chartOptions = data.chartOptions
        this.loading = false
      }
    }
  },
  watch: {
    '$route.params.station_id': function () {
      this.totalData = null
      this.tableCols = null
      this.tableRows = null
      this.csv = null
      this.chartOptions = null
    }
  },
  created () {
    // Create anchor element for CSV download
    this.csvAnchor = document.createElement('a')
    // Get current date in proper format
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const yyyy = today.getFullYear()
    this.date = yyyy + '-' + mm + '-' + dd
    this.start = this.date
    this.end = this.date
  },
  methods: {
    // Request report data from server
    generateReport () {
      this.loading = true
      const endDate = (this.extra.singleDate) ? this.start : this.end
      const data = { startDate: this.start, endDate: endDate, id: this.extra.id, tableOptions: this.extra.tableOptions }
      this.$socket.emit('getTable', data)
    },
    // Download report as CSV
    downloadCSVData () {
      this.csvAnchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.csv)
      this.csvAnchor.target = '_blank'
      this.csvAnchor.download = 'data.csv'
      this.csvAnchor.click()
    }
  }
}
</script>
